import { Platform } from '@/utils/platform';
import { invoke } from '../../QTBridge';

export const getToken = () => {
  if (Platform.isPOPO && Platform.isPC) {
    return invoke('getToken', {});
  }
  return Promise.reject('不是pc客户端');
};
